import type { IntlShape } from 'react-intl'
import type { AuxiliaryBusinessNameHeader } from './types'

export const auxiliaryBusinessNameHeaders: AuxiliaryBusinessNameHeader[] = [
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Nimi',
				description: 'Table column header: Name',
			}),
		key: 'name',
		show: true,
		sortable: true,
		type: 'string',
		fullWidth: false,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Lähiosoite',
				description: 'Table column header: Street address',
			}),
		key: 'address',
		show: true,
		sortable: true,
		type: 'string',
		fullWidth: false,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Postinumero',
				description: 'Table column header: Postal code',
			}),
		key: 'postalCode',
		show: true,
		sortable: true,
		type: 'string',
		fullWidth: false,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Postitoimipaikka',
				description: 'Table column header: City / Post office',
			}),
		key: 'city',
		show: true,
		sortable: true,
		type: 'string',
		fullWidth: false,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Puhelin',
				description: 'Table column header: Phone',
			}),
		key: 'phone',
		show: true,
		sortable: true,
		type: 'string',
		fullWidth: false,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Faksinumero',
				description: 'Table column header: Fax number',
			}),
		key: 'faxNumber',
		show: true,
		sortable: true,
		type: 'string',
		fullWidth: false,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Sähköposti',
				description: 'Table column header: Email',
			}),
		key: 'email',
		show: true,
		sortable: true,
		type: 'string',
		fullWidth: false,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Internetosoite',
				description: 'Table column header: Website',
			}),
		key: 'website',
		show: true,
		sortable: true,
		type: 'string',
		fullWidth: false,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Kustannuspaikka',
				description: 'Table column header: Cost center',
			}),
		key: 'costCenter',
		show: true,
		sortable: true,
		type: 'string',
		fullWidth: false,
	},
]

export const bankAccountHeaders: AuxiliaryBusinessNameHeader[] = [
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Tilinumero',
				description: 'Table column header: Bank account number',
			}),
		key: 'bankAccountNumber',
		show: true,
		sortable: true,
		type: 'string',
		fullWidth: false,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Pankki',
				description: 'Table column header: Bank',
			}),
		key: 'bank',
		show: true,
		sortable: true,
		type: 'string',
		fullWidth: false,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'IBAN',
				description: 'Table column header: IBAN',
			}),
		key: 'iban',
		show: true,
		sortable: true,
		type: 'string',
		fullWidth: false,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'BIC',
				description: 'Table column header: BIC',
			}),
		key: 'bic',
		show: true,
		sortable: true,
		type: 'string',
		fullWidth: false,
	},
]
